@if (dokumente().length || state() !== 'success') {
  <h3 class="font-bold text-lg text-cp-primary-100 mb-3">Tarifdokumente</h3>

  @if (dokumente().length) {
    <div class="flex flex-col gap-4">
      @for (doc of dokumente(); track doc.id) {
        <ui-dokument-download-button [doc]="doc" />
      }
    </div>
  } @else if (state() === 'error') {
    <p class="text-sm text-cp-error-100">
      Preis und Dokumente konnten nicht abgerufen werden. Bitte laden Sie die Seite neu.
    </p>
  } @else {
    <!-- skeleton of the document list, same shape as the download links above -->
    <div class="flex flex-col gap-4" aria-busy="true">
      <div class="ghost h-6 w-3/4"></div>
      <div class="ghost h-6 w-1/2"></div>
    </div>
  }
}
